import React from 'react';
import { connect } from 'react-redux';
import { PubNubConsumer } from 'pubnub-react';
import UserManagementComponent from './UserManagementComponent';

import { changeLocation, loadLocations } from '../../actions/dashboard-actions';

//import { teamOperations, teamUtils, teamActions } from './duck';
import { userManagementOperations } from './duck';
import { appActions } from 'App/duck';
import { userManagementActions } from './duck';


const mapStateToProps = ({
  teamReducer,
  locationReducer,
  appReducer,
  userManagementReducer,
}) => {
  return {
    locationSettings: appReducer.location.settings,
    locationId: locationReducer.location_code,
    locationData: locationReducer.location_data,
    locations: locationReducer.locations,
    visibleMembers: teamReducer.visibleMembers,
    bottomSheet: teamReducer.bottomSheet,
    searchTerm: teamReducer.search.searchTerm,
    searching: teamReducer.search.searching,
    activeFilter: userManagementReducer.filters.activeFilter,
    filters: userManagementReducer.filters.filters,
    //managers: userManagementReducer.managers.users,
    managers: appReducer.managers.users,
    managersCurrentPage: userManagementReducer.managers.page,
    managersTotalPages: userManagementReducer.managers.totalPages,
    //associates: userManagementReducer.associates.users,
    associates: appReducer.associates.users,
    //allUsers: userManagementReducer.allUsers.users,
    allUsers: appReducer.allUsers.users,
    associatesCurrentPage: userManagementReducer.associates.page,
    associatesTotalPages: userManagementReducer.associates.totalPages,
    //removedUsers: userManagementReducer.removedUsers.users,
    removedUsers: appReducer.removedUsers.users,
    removedUsersCurrentPage: userManagementReducer.removedUsers.page,
    removedUsersTotalPages: userManagementReducer.removedUsers.totalPages,
    //pendingUsers: userManagementReducer.pendingUsers.users,
    pendingUsers: appReducer.pendingUsers.users,
    departments: appReducer.departments.data,
    //channels: userManagementReducer.channels.data,
    channels: appReducer.channels.data,
    skills: appReducer.skills.data,
    channelMembers: appReducer.users.data,
    channelData: userManagementReducer.channelMembers.data,
    //loadingAssociates: userManagementReducer.associates.loading,
    //loadingManagers: userManagementReducer.managers.loading,
    //loadingRemovedUsers: userManagementReducer.removedUsers.loading,
    //loadingChannelMembers: userManagementReducer.channelMembers.loading,
    loadingAssociates: appReducer.associates.loading,
    loadingManagers: appReducer.managers.loading,
    loadingRemovedUsers: appReducer.removedUsers.loading,
    //lastAction: userManagementReducer.managers.lastAction,
    lastAction: appReducer.managers.lastAction,
    lastOperation: userManagementReducer.managers.lastOperation,
    error: userManagementReducer.allUsers.error,
  };
};

const mapDispatchToProps = (dispatch) => {

  const fetchMetadata = (locationId, searchTerm) => {
    dispatch(userManagementOperations.fetchMetadata(locationId, searchTerm));
  };
  const fetchActiveUsers = (locationId, pageNo, numPerPage) => {
    dispatch(userManagementOperations.fetchActiveUsers(locationId, pageNo, numPerPage));
  };
  const fetchRemovedUsers = (locationId, pageNo, numPerPage) => {
    dispatch(userManagementOperations.fetchRemovedUsers(locationId, pageNo, numPerPage));
  };
  const fetchPendingUsers = (locationId, pageNo, numPerPage) => {
    dispatch(userManagementOperations.fetchPendingUsers(locationId, pageNo, numPerPage));
  };
  const fetchManagers = (locationId, pageNo, numPerPage) => {
    dispatch(userManagementOperations.fetchManagers(locationId, pageNo, numPerPage));
  };
  const fetchAssociates = (locationId, pageNo, numPerPage) => {
    dispatch(userManagementOperations.fetchAssociates(locationId, pageNo, numPerPage));
  };
  const fetchAllUsers = (locationId, pageNo, numPerPage) => {
    dispatch(userManagementOperations.fetchAllUsers(locationId, pageNo, numPerPage));
  };
  const getLocationInnerDepartments = (locationId) => {
    dispatch(userManagementOperations.getLocationInnerDepartments(locationId));
  };
  const getLocationUsableSkills = (locationId) => {
    dispatch(userManagementOperations.getLocationUsableSkills(locationId));
  };
  const requestChannelMembers = () => {
    dispatch(userManagementActions.requestChannelMembers(true));
  };
  const fetchChannelMembers = (channelId, channelName) => {
    dispatch(userManagementOperations.fetchChannelMembers(channelId, channelName));
  };
  const getLocationChannels = (locationId) => {
    dispatch(userManagementOperations.getLocationChannels(locationId));
  };
  const handlePromote = (userPrivileges) => {
    dispatch(userManagementOperations.updateAdminStatus(userPrivileges, true));
  };

  const handleWithdraw = (userPrivileges) => {
    dispatch(userManagementOperations.updateAdminStatus(userPrivileges, false));
  };

  const handleApprove = (userPrivilegeId, locationId) => {
    dispatch(userManagementOperations.approveUser(userPrivilegeId, locationId));
  };

  const handleDeny = (users, locationId) => {
    dispatch(userManagementOperations.denyUser(users, locationId));
  };

  const handleRemove = (admins, nonAdmins, locationId) => {
    dispatch(userManagementOperations.removeUser(admins,  nonAdmins, locationId));
  };

  const resetManagers = () => {
    dispatch(userManagementActions.resetManagers(true));
  };

  const resetAssociates = () => {
    dispatch(userManagementActions.resetAssociates(true));
  };

  const resetRemovedUsers = () => {
    dispatch(userManagementActions.resetRemovedUsers(true));
  };

  const resetPendingUsers = () => {
    dispatch(userManagementActions.resetPendingUsers(true));
  };

  const resetAllUsers = () => {
    dispatch(userManagementActions.resetAllUsers(true));
  };

  const handleCreateGroup = (groupName, locationId, description) => {
    dispatch(userManagementOperations.createGroup(groupName, locationId, description));
  };

  const handleCreateDepartment = (deptName, locationId, description) => {
    dispatch(userManagementOperations.createDepartment(deptName, locationId, description));
  };

  const handleCreateSkill = (skillName, locationId, description) => {
    dispatch(userManagementOperations.createSkill(skillName, locationId, description));
  };

  const handleAddUserToGroup = (channelId, users) => {
    dispatch(userManagementOperations.addUserToGroup(channelId, users));
  };

  const handleRemoveUserFromGroup = (channelId, users, memberCount) => {
    dispatch(userManagementOperations.removeUserFromGroup(channelId, users, memberCount));
  };

  const handleAddUserToDepartment = (users, departmentId) => {
    dispatch(userManagementOperations.addUserToDepartment(users, departmentId));
  };

  const handleRemoveUserFromDepartment = (users, departmentId) => {
    dispatch(userManagementOperations.removeUserFromDepartment(users, departmentId));
  };

  const handleAssignUsersToSkill = (users, locationId, skill) => {
    dispatch(userManagementOperations.assignUsersToSkill(users, locationId, skill));
  };

  const handleRemoveUsersFromSkill = (users, locationId, skill) => {
    dispatch(userManagementOperations.removeUsersFromSkill(users, locationId, skill));
  };

  const handleChangeLocation = (locationId) => {
    dispatch(changeLocation(locationId));
  };

  const handleGetUserInformation = (userPrivilege, locationId) => {
    dispatch(userManagementOperations.getUserInformation1(userPrivilege, locationId));
  };
  
  return { 
    fetchMetadata,
    fetchActiveUsers,
    fetchRemovedUsers,
    fetchPendingUsers,
    fetchManagers,
    fetchAssociates,
    fetchAllUsers,
    getLocationInnerDepartments,
    getLocationUsableSkills,
    requestChannelMembers,
    fetchChannelMembers,
    getLocationChannels,
    handlePromote,
    handleWithdraw,
    handleApprove,
    handleDeny,
    handleRemove,
    resetManagers,
    resetAssociates,
    resetRemovedUsers,
    resetPendingUsers,
    resetAllUsers,
    handleCreateGroup,
    handleCreateDepartment,
    handleCreateSkill,
    handleAddUserToGroup,
    handleRemoveUserFromGroup,
    handleAddUserToDepartment,
    handleRemoveUserFromDepartment,
    handleAssignUsersToSkill,
    handleRemoveUsersFromSkill,
    handleChangeLocation,
    handleGetUserInformation,
  };
};

const UserManagementContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  return (
    <PubNubConsumer>
      {(client) => {
        const { visibleMembers,
                bottomSheet,
                searchTerm,
                searching,
                locationSettings,
                locationId,
                locationData,
                locations,
                managers,
                managersCurrentPage,
                managersTotalPages,
                associates,
                associatesCurrentPage,
                associatesTotalPages,
                removedUsers,
                allUsers,
                removedUsersCurrentPage,
                removedUsersTotalPages,
                pendingUsers,
                departments,
                channels,
                skills,
                channelMembers,
                channelData,
                loadingAssociates,
                loadingManagers,
                loadingRemovedUsers,
                loadingChannelMembers,
                lastAction,
                lastOperation,
                error,

                fetchMetadata,
                fetchActiveUsers,
                fetchRemovedUsers,
                fetchPendingUsers,
                fetchManagers,
                fetchAssociates,
                fetchAllUsers,
                getLocationInnerDepartments,
                getLocationUsableSkills,
                requestChannelMembers,
                fetchChannelMembers,
                getLocationChannels,
                handlePromote,
                handleWithdraw,
                handleApprove,
                handleDeny,
                handleRemove,
                resetManagers,
                resetAssociates,
                resetRemovedUsers,
                resetPendingUsers,
                resetAllUsers,
                handleCreateGroup,
                handleCreateDepartment,
                handleCreateSkill,
                handleAddUserToGroup,
                handleRemoveUserFromGroup,
                handleAddUserToDepartment,
                handleRemoveUserFromDepartment,
                handleAssignUsersToSkill,
                handleRemoveUsersFromSkill,
                handleChangeLocation,
                handleGetUserInformation,
              } = props;

        return (
          <UserManagementComponent
            pubnub={client}
            visibleMembers={visibleMembers}
            bottomSheet={bottomSheet}
            searchTerm={searchTerm}
            searching={searching}
            locationSettings={locationSettings}
            locationId={locationId}
            locationData={locationData}
            locations={locations}
            managers={managers}
            managersCurrentPage={managersCurrentPage}
            managersTotalPages={managersTotalPages}
            associates={associates}
            associatesCurrentPage={associatesCurrentPage}
            associatesTotalPages={associatesTotalPages}
            removedUsers={removedUsers}
            removedUsersCurrentPage={removedUsersCurrentPage}
            removedUsersTotalPages={removedUsersTotalPages}
            pendingUsers={pendingUsers}
            allUsers={allUsers}
            departments={departments}
            channels={channels}
            skills={skills}
            channelMembers={channelMembers}
            channelData={channelData}
            loadingAssociates={loadingAssociates}
            loadingManagers={loadingManagers}
            loadingRemovedUsers={loadingRemovedUsers}
            loadingChannelMembers={loadingChannelMembers}
            lastAction={lastAction}
            lastOperation={lastOperation}
            error={error}

            fetchMetadata={fetchMetadata}
            fetchActiveUsers={fetchActiveUsers}
            fetchRemovedUsers={fetchRemovedUsers}
            fetchPendingUsers={fetchPendingUsers}
            fetchManagers={fetchManagers}
            fetchAssociates={fetchAssociates}
            fetchAllUsers={fetchAllUsers}
            getLocationInnerDepartments={getLocationInnerDepartments}
            getLocationUsableSkills={getLocationUsableSkills}
            requestChannelMembers={requestChannelMembers}
            fetchChannelMembers={fetchChannelMembers}
            getLocationChannels={getLocationChannels}
            handlePromote={handlePromote}
            handleWithdraw={handleWithdraw}
            handleApprove={handleApprove}
            handleDeny={handleDeny}
            handleRemove={handleRemove}
            resetManagers={resetManagers}
            resetAssociates={resetAssociates}
            resetRemovedUsers={resetRemovedUsers}
            resetPendingUsers={resetPendingUsers}
            resetAllUsers={resetAllUsers}
            handleCreateGroup={handleCreateGroup}
            handleCreateDepartment={handleCreateDepartment}
            handleCreateSkill={handleCreateSkill}
            handleAddUserToGroup={handleAddUserToGroup}
            handleRemoveUserFromGroup={handleRemoveUserFromGroup}
            handleAddUserToDepartment={handleAddUserToDepartment}
            handleRemoveUserFromDepartment={handleRemoveUserFromDepartment}
            handleAssignUsersToSkill={handleAssignUsersToSkill}
            handleRemoveUsersFromSkill={handleRemoveUsersFromSkill}
            handleChangeLocation={handleChangeLocation}
            handleGetUserInformation={handleGetUserInformation}

          />
        );
      }}
    </PubNubConsumer>
  );
});

export default UserManagementContainer;
